import type { MenuOption } from "@dealer-center/core-components";
import { Cog8ToothIcon, MenuButton } from "@dealer-center/core-components";

export function TabOverflowDropdown(props: {
  accountSearchHistoryEnable: boolean;
  setAccountSearchHistoryEnable: (enabled: boolean) => void;
  accountSearchFavoritesEnable: boolean;
  setAccountSearchFavoritesEnable: (enabled: boolean) => void;
}) {
  const options: MenuOption[] = [
    {
      label: "Additional options",
      divider: true,
      disabled: true,
      value: ""
    },
    {
      label: props.accountSearchHistoryEnable
        ? "Hide Search History"
        : "Show Search History",
      value: "showsearchhistory",
      onSelect: () => {
        props.setAccountSearchHistoryEnable(!props.accountSearchHistoryEnable);
      }
    },
    {
      label: props.accountSearchFavoritesEnable
        ? "Hide Search Favorites"
        : "Show Search Favorites",
      value: "showsearchfavorites",
      onSelect: () => {
        props.setAccountSearchFavoritesEnable(
          !props.accountSearchFavoritesEnable
        );
      }
    }
  ];
  return (
    <MenuButton
      ButtonProps={{
        buttonStyle: "aux",
        icon: <Cog8ToothIcon title="Additional options" />
      }}
      MenuProps={{
        menuOptions: options
      }}
    />
  );
}
